export default {
  name: 'Email Address',
  edit: {
    form: 'email-input',
    label: 'Change Email Address',
    handler: value => value,
  },
};
